(function () {
  const getBarSettings = (progressBar) => ({
    slidesPerView: 2,
    spaceBetween: 16,
    speed: 400,
    allowTouchMove: true,
    mousewheel: {
      forceToAxis: true,
    },
    watchSlidesProgress: true,
    breakpoints: {
      990: {
        slidesPerView: 3,
      },
      1440: {
        slidesPerView: 4,
      },
    },
    scrollbar: progressBar
      ? {
          el: progressBar,
          grabCursor: true,
          draggable: true,
          hide: false,
        }
      : false,
  });

  const getSliderSettings = (swiperEl, nextBtn, prevBtn) => {
    const mobSlidesPreView = swiperEl.classList.contains(
      "products-tabs__layout--visible-overflow"
    )
      ? "auto"
      : 1;

    return {
      slidesPerView: mobSlidesPreView,
      spaceBetween: 16,
      speed: 500,
      allowTouchMove: true,
      navigation:
        nextBtn && prevBtn
          ? {
              nextEl: nextBtn,
              prevEl: prevBtn,
              disabledClass: "swiper-button-disabled",
            }
          : false,
    };
  };

  const initSliders = (root, settings) => {
    const swiperEls = root.querySelectorAll(".products-tabs__layout");

    swiperEls.forEach((swiperEl) => {
      const swiperWrapper = swiperEl.querySelector(".products-tabs__list");
      const slides = swiperEl.querySelectorAll(".products-tabs__item");

      if (!swiperWrapper || !slides.length) return;

      swiperEl.classList.add("swiper");
      swiperWrapper.classList.add("swiper-wrapper");
      slides.forEach((slide, index) => {
        slide.classList.add("swiper-slide");
        let coeff = slides.length > 12 ? 0.05 : 0.1;

        if (slides.length > 24) {
          coeff = 0.02;
        }

        const delay = index * coeff;
        slide.style.setProperty("--prod-tabs-item-delay", `${delay}s`);
      });

      const progressBar = swiperEl.querySelector(".swiper-scrollbar");
      const nextBtn = swiperEl.querySelector(
        ".products-tabs__navigation-button-next"
      );
      const prevBtn = swiperEl.querySelector(
        ".products-tabs__navigation-button-prev"
      );

      new Swiper(
        swiperEl,
        settings === "bar"
          ? getBarSettings(progressBar)
          : getSliderSettings(swiperEl, nextBtn, prevBtn)
      );
    });
  };

  const destroySliders = (root) => {
    const swiperEls = root.querySelectorAll(".products-tabs__layout");

    swiperEls.forEach((swiperEl) => {
      const swiperWrapper = swiperEl.querySelector(".products-tabs__list");
      const slides = swiperEl.querySelectorAll(".products-tabs__item");

      if (!swiperEl?.swiper || !slides.length || !swiperWrapper) return;

      swiperEl.swiper.destroy(true, true);

      swiperEl.classList.remove("swiper");
      swiperWrapper.classList.remove("swiper-wrapper");
      slides.forEach((slide) => slide.classList.remove("swiper-slide"));
    });
  };

  const toggleTab = (section) => {
    const tabsEls = section.querySelectorAll(".products-tabs__tab");
    const productsEls = section.querySelectorAll(".products-tabs__layout");

    const onToggleTab = (event, tab) => {
      event.preventDefault();
      if (tab.classList.contains("active")) return;
      const tabId = tab.dataset.productsTabId;

      tabsEls.forEach((el) => {
        el.classList.remove("active");
      });

      productsEls.forEach((el) => {
        el.classList.remove("active");

        if (el.swiper) {
          el.swiper.slideTo(0, 0);
        }
      });

      const productsActiveEl = section.querySelector(
        `.products-tabs__layout[data-products-tab-id="${tabId}"]`
      );
      tab.classList.add("active");
      productsActiveEl.classList.add("active");
    };

    tabsEls.forEach((tab) => {
      tab.addEventListener("click", (event) => onToggleTab(event, tab));

      tab.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          onToggleTab(event, tab);
        }
      });
    });
  };

  const initProductsTabsRoot = (root) => {
    if (!root) {
      return;
    }

    const sliderContainers = root.querySelectorAll(".products-tabs");
    if (!sliderContainers.length) {
      return;
    }

    sliderContainers.forEach((sliderContainer) => {
      const cardsLayout = sliderContainer.dataset.layout || "grid";
      const cardsMobileLayout = sliderContainer.dataset.layoutMobile || "column";
      let currentLayout = null;

      const resizeObserver = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          let newLayout;

          if (entry.contentRect.width < 576) {
            newLayout = cardsMobileLayout === "slider" ? "slider" : "column";
          } else {
            newLayout = cardsLayout === "bar" ? "bar" : "grid";
          }

          if (newLayout !== currentLayout) {
            currentLayout = newLayout;

            destroySliders(sliderContainer);

            if (newLayout === "slider" || newLayout === "bar") {
              initSliders(sliderContainer, newLayout);
            }
          }
        });
      });

      resizeObserver.observe(sliderContainer);
    });

    toggleTab(root);
  };

  const initProductsTabs = (section) => {
    initProductsTabsRoot(section);
  };

  const animateProductCards = (section) => {
    if (!section) {
      return;
    }

    const productsTabsInners = section.querySelectorAll(
      ".products-tabs__inner.animate-on-scroll"
    );

    if (!productsTabsInners.length) return;

    productsTabsInners.forEach((productsTabsInner) => {
      if (productsTabsInner.dataset.scrollAnimated === "true") return;

      ScrollTrigger.create({
        trigger: productsTabsInner,
        start: "20% bottom",
        end: "bottom top",
        onEnter: () => {
          productsTabsInner.classList.add("animated");
          productsTabsInner.dataset.scrollAnimated = "true";
        },
      });
    });
  };

  initProductsTabs(document.currentScript.parentElement);

  animateProductCards(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initProductsTabs(event.target);
    animateProductCards(event.target);
  });
})();
